// ------------------------------------
// Action Types & Creators
// ------------------------------------\

export const SUBSCRIPTION_DETAILS = 'foodsby/subscriptions/SUBSCRIPTION_DETAILS'
export const SUBSCRIPTION_PROMO_PREFERENCE = 'foodsby/subscriptions/SUBSCRIPTION_PROMO_PREFERENCE'
export const RESET_SUBSCRIPTION_STATE = 'foodsby/subscriptions/RESET_SUBSCRIPTION_STATE'

export const addSubscriptionDetails = details => ({
  payload: { details },
  type: SUBSCRIPTION_DETAILS,
})

export const addSubscriptionPromoPreference = preferences => ({
  payload: { preferences },
  type: SUBSCRIPTION_PROMO_PREFERENCE,
})

export const resetSubscriptionState = () => ({
  type: RESET_SUBSCRIPTION_STATE,
})

// ------------------------------------
// Action Handlers
// ------------------------------------

const ACTION_HANDLERS = {
  [RESET_SUBSCRIPTION_STATE]: () => initialState,
  [SUBSCRIPTION_DETAILS]: (state, action) => ({
    ...state,
    subscriptionDetails: action.payload.details,
  }),
  [SUBSCRIPTION_PROMO_PREFERENCE]: (state, action) => ({
    ...state,
    subscriptionPromoPreference: {
      ...state?.subscriptionPromoPreference,
      ...action.payload.preferences,
    },
  }),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}

export default function subscriptions(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}
